export default __webpack_public_path__ + "1af5b921916fb0b232f05b1d4f3d5d35.webp";